import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
export default grapesjs.plugins.add('chat-bot-messaging', (editor, opts = {}) => {
  let options = opts || {};

  let defaults = {
    pfx: 'chat-bot-messaging',
    blocks: ['chat-bot-messaging'],
    defaultStyle: true,
    label: 'Chatbot Message',
    category: 'Advanced',
    type: 'chat-bot-messaging',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }

  loadComponents(editor, options);
  loadBlocks(editor, options);
});
